import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { Picklist } from '../models/picklist.model';
import { Repository } from './repository';

import { Service } from '../entity';
import { tap } from 'rxjs/operators';

@Service({
  api: 'picklist',
  model: Picklist,
})
@Injectable({ providedIn: 'root' })
export class PicklistService extends Repository<Picklist> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).appConfig,
    });
  }

  getAll(queryParams?: any) {
    return super.getAll<Picklist[]>(queryParams).pipe(
      tap((result) => {
        result.items.sort((a, b) => {
          if (a.picklistName < b.picklistName) {
            return -1;
          }
          if (a.picklistName > b.picklistName) {
            return 1;
          }
          return 0;
        });
      })
    );
  }

  getOne(queryParams?) {
    return super.getOne<Picklist>(queryParams, queryParams.id);
  }

  createFromDTO(item): Picklist {
    return Picklist.createFromDTO(item);
  }
}
